import React, { useState } from "react";
import { connect } from "react-redux";
import Maincontent from "./Maincontent";
import SalaryIncreament from "./increament/SalaryIncreament";
import SalaryIncreamentByAmount from "./increament/SalaryIncreamentByAmount";

import { Layout, Breadcrumb, Tabs } from "antd";
const { Content } = Layout;

const UserRole = () => {
  const [updatelist, setUpdatelist] = useState(true);

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Employee Salary Details</Breadcrumb.Item>
      </Breadcrumb>

      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab="Salary Details" key="1">
          <Maincontent />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Salary Increament" key="2">
          <SalaryIncreament />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Salary Increament By Amount" key="3">
          <SalaryIncreamentByAmount />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
};

export default connect()(UserRole);